import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

export { dayjs };
